import * as yup from "yup";

export const WorkShiftSchema = (t) => {
  return yup.object().shape({
    title: yup.string().required(t("leave.validation.leave_name_required")),
    start_time: yup.string().required(t("validations.required_field")),
    end_time: yup.string().required(t("validations.required_field")),
  });
};
